<section class="row details-content no-padding no-margin-horizontal margin-top mt40 mobile-margin">
  <app-all-header    [policy]="policy"  *ngIf="!isAcmic" class="w-100"></app-all-header>
  <div class="col-sm-12 col-md col1 " [ngClass]="{'details-all-width-left':isAcmic}">
    <div class="row margin-bottom mb16 policy-holders row-section">
      <div class="col">
        <ng-container *ngIf="isAcmic else masite">
          <h2 class="title margin-bottom mb16 fw-400"> {{ 'POLICY_HOLDER' | translate }}
          </h2>
        </ng-container>
         <ng-template #masite>
          <h2 class="title margin-bottom mb16">
            {{ 'POLICY_HOLDER_ONE_WORD' | translate }}
          </h2>
         </ng-template>
        

        <div class="policy-holder margin-bottom  row"
          *ngFor="let holder of policy?.insured | sort: 'isPrimaryInsured'" [ngClass]="{'no-margin-horizontal gap-8 mb8 policy-holder-subcontainer': !isAcmic, 'policy-overview-ml1': isAcmic}">
          <ng-container *ngIf="isAcmic; else nonacmicholder">
            <div class="policy-holder-info">
              <h3 class="title vehicle-name veh-color">
                  <!-- <img src="./assets/img/images/icon-user.svg" alt="user icon" /> -->
                  {{ holder["Insured Name"] | titlecase }}
              </h3>
            </div>
          </ng-container>
          <ng-template #nonacmicholder>
            <div class="policy-holder-info col-auto" [ngClass]="{'no-padding-horizontal car-holder-name': !isAcmic}">
              <img src="./assets/img/images/icon-user.svg" class="margin-right mr8" alt="user icon" *ngIf="isAcmic" /> 
              <h3 class="title vehicle-name veh-color">
              {{ holder['Insured Name'] | titlecase }}
              </h3>
            </div>
            <div class="col" *ngIf="holder?.isPrimaryInsured" [ngClass]="{'no-padding-horizontal car-holder-type-container': !isAcmic}">
              <span class="fs-16 veh-sub-color" [ngClass]="{'car-holder-type': !isAcmic, 'fs-14': isAcmic}">{{ 'PRIMARY' | translate }}</span>
            </div>
            <div class="col" *ngIf="!holder?.isPrimaryInsured" [ngClass]="{'no-padding-horizontal car-holder-type-container': !isAcmic}">
              <span class="fs-16 veh-sub-color" [ngClass]="{'car-holder-type': !isAcmic, 'fs-14': isAcmic}">{{ 'SECONDARY' | translate }}</span>
            </div>
          </ng-template>
          

          <div class="col col-526570" [ngClass]="{ 'MT2': !isAcmic, 'col-656565-imp': isAcmic }" *ngIf="holder?.isPrimaryInsured && isAcmic">
            <small class="fs-14 lh-24">{{ 'PRIMARY' | translate }}</small>
          </div>
          <div class="col col-526570" [ngClass]="{ 'MT2': !isAcmic, 'col-656565-imp': isAcmic }" *ngIf="!holder?.isPrimaryInsured && isAcmic">
              <small class="fs-14 lh-24">{{ 'SECONDARY' | translate }}</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-bottom mb40 property">
      <div class="col">
        <h2 class="title margin-bottom mb16" [ngClass]="{'fw-400': isAcmic}">
          <ng-container *ngIf="!isAcmic">
            <!-- <img src="{{policy?.displayType?.icon}}" width="24" height="24"  alt="home icon" /> -->
          </ng-container> {{ 'PROPERTY_COVERED' | translate }}
        </h2>
        <div class="margin-bottom mb16">
          <div class="text-capitalize">
            <ng-container *ngIf="policy?.policyType === 'BUSINESS_OWNERS_POLICY'; else no_property_object">
              <strong class="fs-16">
                <ng-container *ngIf="isAcmic">
                  <img src="./assets/img/images/icon-home-24.svg" class="edit-icon-mt-5" alt="home icon" /> 
                </ng-container>
                {{ address }} {{ policy?.property[0]?.address?.city }}, {{ policy?.property[0]?.address?.stateCode }}, {{ policy?.property[0]?.address?.zipCode.code }}
              </strong>
            </ng-container>
            <ng-template #no_property_object>
              <strong class="fs-16" [ngClass]="{'col-363636-imp': isAcmic}">
                <ng-container *ngIf="isAcmic">
                  <!-- <img src="./assets/img/images/icon-home-24.svg" class="edit-icon-mt-5" alt="home icon" />  -->
                </ng-container>
              <div class="text-capitalize d-flex align-items-start address-tag-row">
                <span class="mr16 address-tag-text" *ngIf="!isAcmic">{{ 'ADDRESS' | translate }}</span>
                <strong class="fs-16 address-value-text" [ngClass]="{ 'col-363636-imp': isAcmic }">
                  <img
                    src="{{ policy?.displayType?.icon }}"
                    width="24"
                    height="24"
                    alt="home icon"
                    *ngIf="
                      policy?.company.companyName === 'TW' ||
                      policy?.company.companyName === 'ACIC'
                    "
                  />
                  {{ policy?.residentialAddress?.streetName | titlecase }}
                  <br *ngIf="!isAcmic">
                  {{ policy?.residentialAddress?.city | titlecase }},
                  {{ policy?.residentialAddress?.state | fullstateToAbv }},
                  {{ policy?.residentialAddress?.zipCode.code }}
                </strong>
              </div>
              </strong>
            </ng-template>
          </div>
          <div *ngIf="aptDiv === true">
              {{ 'APARTMENT' | translate}}: <strong> {{ apt }}</strong>
          </div>
        </div>
        <iframe [height]="isMobile ? 220: 360" id="gmap_canvas" [src]="safeURL"
          frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
        </iframe>
      </div>
    </div>
  </div>

<div class="col-sm-12 col-md col2 detials-sidebar"  [ngClass]="{'details-all-width-right details-sidebar-acmic vertical-line-color':isAcmic, 'no-padding-top': !isAcmic}">
    <app-details-sidebar [policy]="policy" (showToast)="showToast.emit($event)"></app-details-sidebar>
  </div>
</section>
